import React from 'react'
import { tuple } from 'antd/es/_util/type'
import { getBEMCls } from '@/utils/classname'
import classNames from 'classnames'
import Wave from 'antd/es/_util/wave'

import './button.scss'

const ButtonTypes = tuple('error', 'more', 'default', 'primary', 'text', 'danger')
export type ButtonType = typeof ButtonTypes[number]

interface ButtonProps {
    types?: ButtonType
    onClick?: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>) => void
    disabled?: boolean
    loading?: boolean
}

const Button: React.FC<ButtonProps & React.ButtonHTMLAttributes<any>> = props => {
    const getCls = (el?: string, moder?: string) => getBEMCls('sg-button', el, moder)
    const { loading, types, className, onClick, disabled, type = 'button', ...reset } = props

    const classes = classNames(
        getCls(),
        {
            [`${getCls(types)}`]: types && !disabled,
            [`${getCls('disabled')}`]: disabled,
            [`${getCls('loading')}`]: loading,
        },
        className,
    )

    return (
        <Wave>
            <button
                onClick={e => {
                    if (!(disabled || loading)) onClick && onClick(e)
                }}
                className={classes}
                disabled={disabled}
                type={type}
                {...reset}
            >
                {loading && <div className={getCls('rotate')} />}
                {props.children}
                {types === 'more' && <i className={`${getCls('more-icon')} iconfont icon6xiala2-20`} />}
            </button>
        </Wave>
    )
}

export default Button
